import { h, render, Component } from 'preact';
import { classNames } from '../utils/utils';

class TxrDropdown extends Component {
    state = {
        isOpened: false
    }

    getFirstError = () => {
        let errors = Object.entries(this.props.model.errors);
        let firstError = '';
        for (const [key, value] of errors) {
            if (!!value) {
                firstError = this.props.errors[key];
                this.hasError = true;
                return firstError;
            }
        }
        this.hasError = false;
        return '';
    }
    toggle = () => {
        this.setState({ isOpened: !this.state.isOpened });
        if (this.props.onToogle) {
            this.props.onToogle(!this.state.isOpened);
        }
        //  <label class="txr-input__label">{this.props.label}</label>
    }
    close = () => {
        this.setState({ isOpened: false });
    }
    txrSelect = (option) => {
        this.props.model.touched = true;
        this.props.model.value = option;
        if (this.props.model.change) {
            this.props.model.change(this.props.model);
        }
        this.setState({ isOpened: false });
        if (this.props.onToogle) {
            this.props.onToogle(false);
        }
    }

    render() {
        return (
            <div class={'txr-dropdown' + (this.props.model.invalid ? ' invalid' : '') + (this.props.model.value ? ' has-value' : '') + (this.state.isOpened ? ' txr-dropdown__opened' : '')}>
                <div class="txr-dropdown__container">
                    <div class="dropdown">
                        <button class="txr-dropdown__button" type="button" onClick={() => this.toggle()}>
                            <span class="txr-dropdown__title">{this.props.model.value ? this.props.model.value.title : this.props.label}</span>
                            <i class="txr-dropdown__icon fal fa-angle-down"></i>
                        </button>
                        <div class="txr-dropdown__items" >
                            <div class="txr-dropdown__rule"></div>
                            {
                                this.props.options.map(option =>
                                    <a class="txr-dropdown__item" onClick={(e) => this.txrSelect(option)}>{option.title}</a>
                                )
                            }
                        </div>
                    </div>

                    {this.props.rightSlot &&
                        <div class="txr-input__right-slot">
                            {this.props.rightSlot}
                        </div>
                    }
                </div>
                {this.props.errors &&
                    <div class="txr-input__errors">
                        {this.getFirstError()}
                    </div>
                }
                {this.props.bottomSlot &&
                    <div class="txr-input__bottom-slot">{this.props.bottomSlot}</div>
                }

            </div>
        )
    }
}

export default TxrDropdown;